import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsNumber, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(['bannedUserId', 'normalizedIp'], { unique: true })
export class BannedIpSnapshot extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  bannedUserId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: false })
  normalizedIp: string;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  weightMilli: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  sourceDistinctIpCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  sourceRequestCount: number;
}
